import Dexie from "dexie";

// Base local propia del módulo — mismo patrón que localDB.js en BAC
// Sarampión. Ahora solo guarda la cola de pendientes: ya no hay catálogo
// de instituciones que cachear (el formulario de disentimiento no lo usa).
export const db = new Dexie("ConsentimientoDB");

// v1 — esquema original del módulo de consentimiento (se conserva
// declarado para que Dexie pueda migrar los dispositivos que ya lo tengan).
db.version(1).stores({
  consentimiento_instituciones_cache: "id, nombre",
  consentimiento_pendientes: "++id, codigo, sincronizado, createdAt",
});

// v2 — pivote a disentimiento: se eliminan las tablas viejas (las
// instituciones ya no existen, y los pendientes viejos tenían otro
// formato que el servidor nuevo ya no acepta) y se crea la cola nueva.
db.version(2).stores({
  consentimiento_instituciones_cache: null,
  consentimiento_pendientes: null,
  disentimiento_pendientes: "++id, codigo, sincronizado, createdAt",
});

export default db;